import { useFavoritesContext } from "@/context/FavoritesContext";

interface FavoriteButtonProps {
  dramaId: string;
  dramaTitle: string;
  onFeedback?: (message: string) => void;
  variant?: "solid" | "outline";
}

export default function FavoriteButton({
  dramaId,
  dramaTitle,
  onFeedback,
  variant = "solid",
}: FavoriteButtonProps) {
  const { isFavorite, toggleFavorite } = useFavoritesContext();
  const active = isFavorite(dramaId);

  const handleClick = () => {
    const added = toggleFavorite(dramaId);
    onFeedback?.(added ? `已收藏《${dramaTitle}》，可在本地收藏中随时查看` : `已取消收藏《${dramaTitle}》`);
  };

  const base =
    "flex items-center gap-2 whitespace-nowrap rounded-md px-5 py-2.5 text-sm font-semibold transition-colors";
  const style = active
    ? "bg-accent-500 text-accent-950 hover:bg-accent-600"
    : variant === "solid"
      ? "bg-primary-500 text-background-50 hover:bg-primary-600"
      : "border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600";

  return (
    <button type="button" onClick={handleClick} className={`${base} ${style}`}>
      <span className="flex h-4 w-4 items-center justify-center">
        <i className={active ? "ri-heart-fill" : "ri-heart-line"}></i>
      </span>
      {active ? "已收藏" : "收藏"}
    </button>
  );
}